export default __webpack_public_path__ + "assets/webgl/complete-23.d364ba09.jpg";